import React, { useCallback } from "react";
import PageContainer from "./layout/PageContainer.js";
import HeroSection from "./providerBeta/HeroSection.js";
import Section from "./providerBeta/Section.js";
import Card from "./providerBeta/Card.js";
import FeatureCard from "./providerBeta/FeatureCard.js";
import QuoteCard from "./providerBeta/QuoteCard.js";
import Checklist from "./providerBeta/Checklist.js";
import ProviderTypeCard from "./providerBeta/ProviderTypeCard.js";
import DisclaimerCard from "./providerBeta/DisclaimerCard.js";
import CTASection from "./providerBeta/CTASection.js";
import MultiStepForm from "./providerBeta/MultiStepForm.js";
import {
  BENEFITS,
  BETA_PERKS,
  HOW_IT_WORKS_STEPS,
  PROBLEM_BULLETS,
  PROVIDER_TYPES,
  SHAPE_CHECKLIST
} from "../constants/providerBeta.js";
import "../provider-beta.css";

const ProviderBeta = () => {
  const scrollToForm = useCallback(() => {
    document.getElementById("provider-beta-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <PageContainer className="provider-beta-page" size="wide">
      <HeroSection onPrimaryClick={scrollToForm} />

      <Section id="how-it-works" title="How It Works">
        <div className="provider-beta__flow">
          {HOW_IT_WORKS_STEPS.map((item, index) => (
            <React.Fragment key={item.key}>
              <Card className="provider-beta__flow-card">
                <h3 className="provider-beta__flow-title">{item.title}</h3>
                <p className="provider-beta__flow-subtitle">{item.subtitle}</p>
              </Card>
              {index < HOW_IT_WORKS_STEPS.length - 1 ? (
                <div className="provider-beta__flow-arrow" aria-hidden="true">
                  →
                </div>
              ) : null}
            </React.Fragment>
          ))}
        </div>
      </Section>

      <Section title="Insights Don't Always Survive Real Life">
        <ul className="provider-beta__bullets">
          {PROBLEM_BULLETS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className="provider-beta__bullets-lead">Clients arrive saying:</p>
        <QuoteCard quote="I don't know what happened." />
      </Section>

      <Section title="Why Providers Are Interested">
        <ul className="provider-beta__benefits-list">
          {BENEFITS.map((item) => (
            <FeatureCard key={item.title} title={item.title} body={item.body} />
          ))}
        </ul>
      </Section>

      <Section title="Who This Is For">
        <table className="provider-beta__types-table">
          <tbody>
            {PROVIDER_TYPES.map((item) => (
              <ProviderTypeCard key={item.title} title={item.title} tags={item.tags} />
            ))}
          </tbody>
        </table>
      </Section>

      <Section title="Provider Beta Users Will Help Us Learn">
        <Checklist items={SHAPE_CHECKLIST} />
      </Section>

      <Section>
        <DisclaimerCard title="Important Note">
          <p>Ahavibes is not therapy.</p>
          <p>
            It is a self-reflection tool and is not intended to diagnose, treat, or replace professional mental
            health care.
          </p>
          <p>
            The platform is designed to complement—not substitute—the relationship between clients and licensed
            professionals.
          </p>
        </DisclaimerCard>
      </Section>

      <Section title="Provider Beta Members Receive">
        <ul className="provider-beta__perks-list">
          {BETA_PERKS.map((perk) => (
            <li key={perk}>{perk}</li>
          ))}
        </ul>
      </Section>

      <CTASection onPrimaryClick={scrollToForm} />

      <Section id="provider-beta-form" title="Apply for Provider Beta" className="provider-beta__form-section">
        <MultiStepForm />
      </Section>
    </PageContainer>
  );
};

export default ProviderBeta;
